class HibikuraBeltPage extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.gallerySlides = [...this.querySelectorAll('[data-gallery-slide]')];
    this.galleryThumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
    this.galleryIndex = Math.max(
      0,
      this.gallerySlides.findIndex((slide) => slide.classList.contains('is-active'))
    );

    this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.stepGallery(-1));
    this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.stepGallery(1));
    this.galleryThumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => this.showGallery(index));
    });

    this.variantInput = this.querySelector('[data-variant-input]');
    this.price = this.querySelector('[data-current-price]');
    this.tiers = [...this.querySelectorAll('[data-tier]')];
    this.tiers.forEach((tier) => tier.addEventListener('change', () => this.selectTier(tier)));
    const selectedTier = this.tiers.find((tier) => tier.checked) || this.tiers[0];
    if (selectedTier) this.selectTier(selectedTier, false);

    this.querySelectorAll('[data-color-select]').forEach((select) => {
      select.addEventListener('change', () => this.updateColorMedia(select));
      this.updateColorMedia(select);
    });

    const reviewTrack = this.querySelector('[data-review-track]');
    const reviewStep = () => {
      const card = reviewTrack?.querySelector('.hbf-review');
      return card ? card.getBoundingClientRect().width + 18 : 320;
    };
    this.querySelector('[data-review-prev]')?.addEventListener('click', () => {
      reviewTrack?.scrollBy({ left: -reviewStep(), behavior: 'smooth' });
    });
    this.querySelector('[data-review-next]')?.addEventListener('click', () => {
      reviewTrack?.scrollBy({ left: reviewStep(), behavior: 'smooth' });
    });

  }

  showGallery(index) {
    if (!this.gallerySlides.length) return;
    const next = (index + this.gallerySlides.length) % this.gallerySlides.length;
    this.gallerySlides.forEach((slide, slideIndex) => {
      const active = slideIndex === next;
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
    });
    this.galleryThumbs.forEach((thumb, thumbIndex) => {
      const active = thumbIndex === next;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', String(active));
      if (active) thumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
    });
    this.galleryIndex = next;
  }

  stepGallery(delta) {
    this.showGallery(this.galleryIndex + delta);
  }

  selectTier(tier, updateUrl = true) {
    if (!tier) return;
    this.tiers.forEach((input) => input.closest('.hbf-tier')?.classList.toggle('is-selected', input === tier));
    if (this.variantInput) this.variantInput.value = tier.value;
    if (this.price && tier.dataset.price) this.price.textContent = tier.dataset.price;

    this.tiers.forEach((input) => {
      const card = input.closest('[data-tier-card]');
      const colors = card?.querySelector('[data-tier-colors]');
      const active = input === tier;
      if (colors) colors.hidden = !active;
      colors?.querySelectorAll('[data-color-select]').forEach((select) => {
        select.disabled = !active;
      });
    });

    if (updateUrl && window.history?.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', tier.value);
      window.history.replaceState({}, '', url);
    }
  }

  updateColorMedia(select) {
    const media = select.closest('.hbf-color')?.querySelector('[data-color-media]');
    if (!media) return;
    const colors = { ブラック: '#171717', ブラウン: '#9c6237', ホワイト: '#f8f6ef' };
    const imageKeys = { ブラック: 'colorImageBlack', ブラウン: 'colorImageBrown', ホワイト: 'colorImageWhite' };
    const imageUrl = this.dataset[imageKeys[select.value]];
    const image = media.querySelector('[data-color-image]');
    media.style.backgroundColor = colors[select.value] || colors['ブラック'];
    if (image && imageUrl) {
      image.src = imageUrl;
      image.hidden = false;
    } else if (image) {
      image.hidden = true;
    }
  }
}

if (!customElements.get('hibikura-belt-page')) {
  customElements.define('hibikura-belt-page', HibikuraBeltPage);
}
